export default __webpack_public_path__ + "static/media/16.4e88a047.jpg";